import { SubmitPlayerGameVotes, VoteType } from "@grassrootly/api";
import useBaseRequest from "../../api/BaseRequest";
import { useUser } from "../../api/auth/AuthSelector";
import { useFetchGame, useFetchGameVotes } from "../../api/game/GameSelector";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../../navigation/Navigation.types";
import { useCallback } from "react";
import { useAlert } from "@grassrootly/rn-core";

export function useGameVote(gameId: number, navigation: NativeStackNavigationProp<RootStackParamList, "vote">) {
  const user = useUser();
  const { fetchGame, game, fetching } = useFetchGame(gameId);
  const { getVotes, loading } = useFetchGameVotes(user?.id!, gameId);
  const { danger } = useAlert();

  const { execute, loading: submitting } = useBaseRequest(SubmitPlayerGameVotes, {
    onCompleted: (data) => {
      fetchGame();
      getVotes();
      navigation.goBack();
    },
  });

  const submitVotes = (votes: Array<{ type: VoteType; attendanceId: number }>) => {
    if (!hasAttended()) {
      danger({ message: "Only players that have played the game can vote.", title: "Not allowed" });
      return;
    }
    execute({
      votes: votes.map((v) => ({ ...v, id: user?.id! })),
    });
  };

  const hasAttended = useCallback(() => {
    return !!game?.attendees?.find((a) => a.player_id === user?.id && a.attended);
  }, [game, user]);

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }
    navigation.replace("main");
  };

  return { game, saving: loading || fetching || submitting, submitVotes, goBack };
}
